import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private isRedirecting = false;

  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {

        // 🔒 Evitar loop infinito en login
        // if (
        //   (error.status === 401 || error.status === 403) &&
        //   !this.isRedirecting
        // ) {
        //   this.isRedirecting = true;

        //   this.router.navigate(['/login']);

        //   setTimeout(() => {
        //     this.isRedirecting = false;
        //   }, 1000);
        // }

        return throwError(() => error);
      })
    );
  }
}
